import { library } from "@fortawesome/fontawesome-svg-core";
import { all } from "@awesome.me/kit-69c6bcafae/icons";

export function initIcons() {
  library.add(...all);
}